import type { MasterProfile } from "../../../types";

export function normalizeCustomerValue(value?: string) {
    return (value ?? "").trim().toLocaleLowerCase("bg-BG");
}

export function normalizeBusinessKey(value?: string) {
    return normalizeCustomerValue(value)
        .replace(/[\"'`„“\.,\-\/]/g, " ")
        .replace(/\b(еоод|оод|еад|ад|ет|сд|кд|ддзд)\b/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}

function buildCompanyGroupKey(value?: string) {
    const tokens = normalizeBusinessKey(value)
        .split(" ")
        .filter((token) => token.length >= 2);

    return tokens.slice(0, 2).join(" ");
}

function areProfilesRelated(left: MasterProfile, right: MasterProfile) {
    const leftKey = normalizeBusinessKey(left.customer);
    const rightKey = normalizeBusinessKey(right.customer);

    if (!leftKey || !rightKey) {
        return false;
    }

    if (leftKey === rightKey) {
        return true;
    }

    const leftGroupKey = buildCompanyGroupKey(left.customer);
    const rightGroupKey = buildCompanyGroupKey(right.customer);

    if (leftGroupKey.length >= 5 && leftGroupKey === rightGroupKey) {
        return true;
    }

    return (
        (leftKey.length >= 6 && rightKey.startsWith(leftKey)) ||
        (rightKey.length >= 6 && leftKey.startsWith(rightKey))
    );
}

export function findRelatedProfiles(profiles: MasterProfile[], currentProfile: MasterProfile) {
    return profiles.filter((profile) => (
        profile.profileId !== currentProfile.profileId &&
        areProfilesRelated(profile, currentProfile)
    ));
}
